import * as React from "react";
import Stack from "@mui/material/Stack";
import NavbarBreadcrumbs from "./NavbarBreadcrumbs";
import Box from "@mui/material/Box";
import SelectContent from "./SelectContent";
import AccountMenu from "./AccountMenu";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlined from "@mui/icons-material/LightModeOutlined";
import { useTheme } from "@mui/material/styles";
import { useColorMode } from "../../../contexts"; // Import the custom hook
import SearchComponent from "../../SearchForm/SearchComponent";
import { useLocation } from "react-router-dom";

interface HeaderProps {
  open: boolean | undefined;
  toggleDrawer: (newOpen: boolean) => void;
}

export default function Header({ open, toggleDrawer }: HeaderProps) {
  // Use the custom hook instead of useContext directly
  const { mode, setMode } = useColorMode();
  const theme = useTheme();
  const location = useLocation();

  const sideMenuToggle = () => {
    const newOpen = !open;
    toggleDrawer(newOpen);
    try {
      localStorage.setItem("sideMenuToggle", JSON.stringify(newOpen));
    } catch (error) {
      console.warn("Could not save sidebar state:", error);
    }
  };

  const handleThemeToggle = () => {
    console.log("Current mode before toggle:", mode);
    console.log("setMode function:", setMode);
    setMode();
  };

  return (
    <Stack
      direction="row"
      sx={{
        display: { xs: "none", md: "flex" },
        width: "100%",
        height: 80,
        alignItems: { xs: "flex-start", md: "center" },
        justifyContent: "space-between",
        backgroundColor: theme.palette.background.paper
      }}
      spacing={2}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          textAlign: "center",
          gap: 1
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: 80,
            height: 80
          }}
        >
          <IconButton
            style={{ borderRadius: 0 }}
            onClick={sideMenuToggle}
            sx={{
              alignSelf: "center",
              color: theme.palette.text.primary
            }}
          >
            {open ? <MenuIcon /> : <MenuOpenIcon />}
          </IconButton>
        </Box>
        <Box
          sx={{
            mt: 1,
            alignSelf: "center"
          }}
        >
          <SelectContent />
        </Box>

        <NavbarBreadcrumbs />
        {location?.pathname === "/audit-list" && <SearchComponent />}
      </Box>

      <Stack direction="row" sx={{ gap: 1, pr: 3.4 }}>
        <IconButton
          style={{ borderRadius: 0 }}
          sx={{
            color: theme.palette.text.primary,
            width: 36,
            height: 36,
            alignSelf: "center"
          }}
          onClick={handleThemeToggle}
          aria-label={`Switch to ${mode === "dark" ? "light" : "dark"} mode`}
        >
          {mode === "dark" ? <LightModeOutlined /> : <DarkModeOutlinedIcon />}
        </IconButton>
        <AccountMenu />
      </Stack>
    </Stack>
  );
}